import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { KPF } from '../../master-data-management/kpf/entities/KPF.js';
import { TeamMeetingAttendance } from './TeamMeetingAttendance.js';

@Entity()
export class TeamMeeting extends MongoEntity {
  public static override _class = 'TeamMeeting';
  public static override _collectionName = 'team-meetings';

  @validate(nonOptional())
  @Field(() => DateTime)
  public when: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(() => DateTime)
  public until: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(() => String)
  public createdBy: Maybe<string>;

  @Field(() => String)
  public comment: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  public kpfId: Maybe<string>;

  @DataLoadedField(() => KPF, ({ kpfId }) => kpfId)
  public kpf: Maybe<KPF>;

  @Field(() => [TeamMeetingAttendance], { default: v => v ?? [] })
  public attendances: Maybe<TeamMeetingAttendance[]>;
}
